// <!-- The core Firebase JS SDK is always required and must be listed first -->
// <script src="https://www.gstatic.com/firebasejs/7.6.1/firebase-app.js"></script>
//
// <!-- TODO: Add SDKs for Firebase products that you want to use
//      https://firebase.google.com/docs/web/setup#available-libraries -->
// <script src="https://www.gstatic.com/firebasejs/7.6.1/firebase-analytics.js"></script>


import firebase from 'firebase';

// Your web app's Firebase configuration
var firebaseConfig = {
    apiKey: "AIzaSyCj5veY1tb0LSiOTaWo6Io9nUCgYlUuHqw",
    authDomain: "limo-carrentals.firebaseapp.com",
    databaseURL: "https://limo-carrentals.firebaseio.com",
    projectId: "limo-carrentals",
    storageBucket: "limo-carrentals.appspot.com",
    messagingSenderId: "316024647702",
    appId: "1:316024647702:web:ed53b2e3d175a6dda88537",
    measurementId: "G-FP5XM49Q1E"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
// firebase.analytics();
